export const apiEndpoint = {
  reviews: "/v1/review",
  adminReviews: "/v3/review",
  adminReviewApprove: (id) => `/v3/review/${id}/approve`,
  adminReviewReject: (id) => `/v3/review/${id}/reject`,
};
